import { Injectable } from '@angular/core';

import { TellentHttpApiService } from '@tellent/http';
import type { CreateTellentApp, TellentApps, TellentAppsResponse } from '@tellent/types';
import type { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TellentAppsHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public fetchApps(): Observable<TellentAppsResponse> {
    return this.httpApi.get('/apps');
  }

  public createApp(data: CreateTellentApp): Observable<{ data: TellentApps }> {
    return this.httpApi.post('/apps', null, data);
  }
}
